// src/hooks/use-permission.js
import { useSelector } from "react-redux";
import { CAPABILITY_ROLES } from "@/config/permissions";

// Fails closed: no roles means no capability. There is deliberately no mock
// or development bypass here — a bypass that grants access when role data is
// missing is indistinguishable from no gate at all.
export const useCurrentRoles = () => {
  const reduxRoles = useSelector((s) => s.auth?.roles ?? []);
  if (Array.isArray(reduxRoles) && reduxRoles.length > 0) return reduxRoles;

  try {
    const saved = JSON.parse(localStorage.getItem("auth:roles") || "[]");
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
};

export const usePermission = (capability) => {
  const roles = useCurrentRoles();
  const allowed = CAPABILITY_ROLES[capability];
  if (!allowed) return false;
  return roles.some((r) => allowed.includes(r));
};